import React from "react";
import classNames from "classnames";

export const CardText = ({ className, justify, center, muted, ...props }) => {
    var cn = classNames("card-text", className, {
        "text-justify": justify,
        "text-center": center,
        "text-muted": muted,
    });
    return (
        <p className={cn} {...props}>
            {props.children}
        </p>
    );
};
